import { render } from "./AddNewDealsModal.vue?vue&type=template&id=08731a54&ts=true"
import script from "./AddNewDealsModal.vue?vue&type=script&lang=ts"
export * from "./AddNewDealsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__